import Title from "@/components/layout/title";

const AccountDeletionPage = () => {
  return (
    <div className="flex flex-col w-full gap-6 px-[5%] pb-8">
      <Title
        title={`Suppression de compte`}
        subTitle={""}
        className="flex flex-col gap-4"
      />

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <h2 className="text-lg font-medium text-gray-900">
            {"Application mobile My Perio App"}
          </h2>
          <p className="text-sm text-gray-600">
            {
              "Vous pouvez supprimer votre compte en allant dans les paramètres de l'application."
            }
          </p>
          <p className="text-sm text-gray-600">
            {
              "Pour cela, vous devez être connecté à votre compte, cliquer sur le dernier bouton de la barre de navigation, puis sur l'icône de paramètres en haut à droite de votre écran, un menu s'ouvrira à droite, cliquer sur le bouton \"Supprimer mon compte\" va supprimer votre compte."
            }
          </p>
          <p className="text-sm text-gray-600">
            {
              "Vous pouvez également supprimer votre compte en en faisant la demande par email à "
            }
            <a href="mailto:myperioapp@gmail.com" className="text-blue-600">
              myperioapp@gmail.com
            </a>
            {"."}
          </p>
          <p className="text-sm text-gray-600">
            {
              "Cette action supprimera votre accès à l'application mais pas les données entrées par votre chirurgien dentiste que vous aurez pu enregistrer ou modifier dans l'application."
            }
          </p>
          <p className="text-sm text-gray-600">
            {
              "Pour supprimer ces données, vous devez en faire la demande par email à "
            }
            <a href="mailto:myperioapp@gmail.com" className="text-blue-600">
              myperioapp@gmail.com
            </a>
            {"."}
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <h2 className="text-lg font-medium text-gray-900">
            {"Application web MyPerioApp"}
          </h2>
          <p className="text-sm text-gray-600">
            {
              "Vous pouvez supprimer votre compte en en faisant la demande par email à "
            }
            <a href="mailto:myperioapp@gmail.com" className="text-blue-600">
              myperioapp@gmail.com
            </a>
            {"."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletionPage;
